import React, { useState } from "react";
import { Button, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import DatePicker from "react-datepicker";
// import {  toast } from "react-toastify";

const AdmissionSiblings = ({
  errors,
  sib,
  index,
  setFormData,
  admissionSiblings,
}) => {
  const [newSibling, setNewSibling] = useState({
    adm_sib_id: 0,
    adm_sib_name: "",
    adm_sib_dob: null,
    adm_sib_school: "",
    adm_sib_gender: "",
  });

  const handleNewSiblingChange = (e) => {
    const { name, value } = e.target;
    setNewSibling((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSiblingChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const updatedEducation = [...prevData.admission_siblings];
      updatedEducation[index] = {
        ...updatedEducation[index],
        [name.replace(/\d+$/, "")]: value,
      };
      return { ...prevData, admission_siblings: updatedEducation };
    });
  };

  const handleNewSiblingDateChange = (date) => {
    setNewSibling((prev) => ({
      ...prev,
      adm_sib_dob: date,
    }));
  };


  const removeSibling = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      admission_siblings: prevData.admission_siblings.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const addSibling = () => {
    //if (!newSibling.adm_sib_name || !newSibling.adm_sib_school || !newSibling.adm_sib_gender) {
    // Optionally you can validate here
    //return toast.error("Please filled ");;
    // }
    setFormData((prevData) => ({
      ...prevData,
      admission_siblings: [...prevData.admission_siblings, newSibling],
    }));
    // Clear new sibling form
    setNewSibling({
      adm_sib_name: "",
      adm_sib_dob: null,
      adm_sib_school: "",
      adm_sib_gender: "",
    });
  };

  return (
    <div>
      <Row className="align-items-end">
        <Col xs={12} md={3}>
          <Form.Group className="mb-3 position-relative">
            <FormattedMessage id="sibling_name">
              {(placeholder) => (
                <Form.Control
                  value={newSibling.adm_sib_name}
                  placeholder={placeholder}
                  type="text"
                  name="adm_sib_name"
                  onChange={handleNewSiblingChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col xs={12} md={2}>
          <Form.Group className="mb-3 position-relative">
            <FormattedMessage id="sibling_age">
              {(placeholder) => (
                <DatePicker
                  placeholderText={placeholder}
                  className="form-control"
                  selected={newSibling.adm_sib_dob}
                  onChange={handleNewSiblingDateChange}
                  dateFormat="dd/MM/yyyy"
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group className="mb-3 position-relative">
            <FormattedMessage id="school_attending">
              {(placeholder) => (
                <Form.Control
                  value={newSibling.adm_sib_school}
                  placeholder={placeholder}
                  type="text"
                  name="adm_sib_school"
                  onChange={handleNewSiblingChange}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group className="mb-3 position-relative">
            <Form.Select
              name="adm_sib_gender"
              onChange={handleNewSiblingChange}
              value={newSibling.adm_sib_gender}
            >
              <option value="">
                <FormattedMessage id="select_gender" />
              </option>
              <option value="F">
                <FormattedMessage id="female" />
              </option>
              <option value="M">
                <FormattedMessage id="male" />
              </option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col xs={12} md={2}>
          <Button variant="primary" onClick={addSibling}>
            + Add Sibling
          </Button>
        </Col>
      </Row>
      
      <hr />
      {admissionSiblings?.map((sib, index) => (
        <Row key={index}>
          <Col md={3}>
            <Form.Group className="mb-4 position-relative">
              <FormattedMessage id="sibling_name">
                {(placeholder) => (
                  <Form.Control
                    value={sib?.adm_sib_name}
                    placeholder={placeholder}
                    type="text"
                    name={`adm_sib_name${index}`}
                    onChange={(e) => handleSiblingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-4 position-relative">
              <FormattedMessage id="sibling_age">
                {(placeholder) => (
                  <DatePicker
                    placeholderText={placeholder}
                    className={
                      errors.adm_sib_dob
                        ? "form-control is-invalid z-20"
                        : "form-control"
                    }
                    selected={
                      sib?.adm_sib_dob ? new Date(sib.adm_sib_dob) : null
                    }
                    onChange={(date) =>
                      setFormData((prevData) => {
                        const updatedSiblings = [
                          ...prevData.admission_siblings,
                        ];
                        updatedSiblings[index] = {
                          ...updatedSiblings[index],
                          adm_sib_dob: date,
                        };
                        return {
                          ...prevData,
                          admission_siblings: updatedSiblings,
                        };
                      })
                    }
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-4 position-relative">
              <FormattedMessage id="school_attending">
                {(placeholder) => (
                  <Form.Control
                    value={sib?.adm_sib_school}
                    placeholder={placeholder}
                    type="text"
                    name={`adm_sib_school${index}`}
                    onChange={(e) => handleSiblingChange(e, index)}
                  />
                )}
              </FormattedMessage>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-4 position-relative">
              <Form.Select
                name={`adm_sib_gender${index}`}
                onChange={(e) => handleSiblingChange(e, index)}
                value={sib?.adm_sib_gender}
              >
                <option value="">
                  <FormattedMessage id="select_gender" />
                </option>
                <option value="F">
                  <FormattedMessage id="female" />
                </option>
                <option value="M">
                  <FormattedMessage id="male" />
                </option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={1}>
            <Button variant="danger" onClick={() => removeSibling(index)}>
              -
            </Button>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default AdmissionSiblings;
